package fr.manyverse.app.infrastructure.shake

import androidx.compose.runtime.Composable
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LocalLifecycleOwner

/**
 * Détecteur de secouage gardé par le cycle de vie : un écran resté en arrière-plan ne lance pas
 * de dés parce que l'appareil a bougé dans une poche.
 *
 * [enabled] ferme la même porte pour un univers où la fonctionnalité des dés est désactivée :
 * secouer l'appareil n'y déclenche alors rien du tout.
 *
 * Le secouage ne fait que **déclencher** le lancer : ni minuteur ni vibration ici. Le résultat
 * arrive quand les dés se couchent, et c'est la simulation elle-même qui fait vibrer l'appareil,
 * choc par choc.
 */
@Composable
fun RememberGuardedShakeDetector(enabled: Boolean = true, onShake: () -> Unit) {
    val lifecycleOwner = LocalLifecycleOwner.current
    rememberShakeDetector {
        if (!enabled) {
            return@rememberShakeDetector
        }
        if (!lifecycleOwner.lifecycle.currentState.isAtLeast(Lifecycle.State.RESUMED)) {
            return@rememberShakeDetector
        }
        onShake()
    }
}
